import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { Checkbox, Switch } from 'antd'
import { elements } from 'style/theme'
import { PermissionsContext } from 'views/UserManagement/Permissions'

const StyledHeader = styled.div({
  display: 'grid',
  gridTemplateColumns: '30px 1fr 138px',
  alignItems: 'center',
  padding: 10,
  border: elements.brandBorder
})

const ProjectName = styled.h1({
  fontSize: 20,
  fontWeight: 500
})

const ProjectAdmin = styled.div({
  label: {
    marginRight: 10
  }
})

const PermissionsItemHeader = props => {
  const { isAccountAdmin } = useContext(PermissionsContext)
  const { id, inProject, isProjectAdmin, name, onHiddenChange, onProjectAdminChange } = props

  return (
    <StyledHeader>
      <Checkbox
        checked={inProject}
        onChange={event => onHiddenChange(id, event.target.checked)}
        name="isHidden"
        disabled={isAccountAdmin}
      />
      <ProjectName>{name}</ProjectName>
      <ProjectAdmin>
        <label>PROJECT ADMIN</label>
        <Switch
          checked={isProjectAdmin || isAccountAdmin}
          onChange={value => onProjectAdminChange(id, value)}
          size="small"
          disabled={!inProject || isAccountAdmin}
        />
      </ProjectAdmin>
    </StyledHeader>
  )
}

export default PermissionsItemHeader
